<app-personalized-dialog [loading]="loading">
  <div dialog-title>Remote Oil Collection</div>
  <div dialog-content>
    <form [formGroup]="form">
      <!-- ── Section 1: Schedule & Route ── -->
      <div class="kite-section-card mb-3">
        <div class="kite-section-title">
          <span>Schedule & Route</span>
        </div>
        <div class="row g-2">
          <div class="col-md-6 col-12">
            <app-custom-input
              label="Start Date"
              type="date"
              [control]="form.get('date_start')!"
            ></app-custom-input>
          </div>
          <div class="col-md-6 col-12">
            <app-custom-input
              label="End Date"
              type="date"
              [control]="form.get('date_end')!"
            ></app-custom-input>
          </div>

          @if(!routeId){
            <div class="col-12 mt-2">
              <app-select-autocomplete
                label="Select Route"
                placeholder="SELECT ROUTE"
                [source]="routes"
                [control]="form.get('route')!"
                labelField="name_route"
                valueField="_id"
              ></app-select-autocomplete>
            </div>
          }
        </div>
      </div>

      <!-- ── Section 2: Collection Details ── -->
      <div class="kite-section-card mb-3">
        <div class="kite-section-title">
          <span>Collection Details</span>
        </div>
        <div class="row g-2">
          <div class="col-12">
            <app-select-autocomplete
              label="Select Client"
              placeholder="SELECT CLIENT"
              [control]="form.get('client')!"
              labelField="name_client_address"
              valueField="_id"
              [debounceSearch]="true"
              [source]="clients"
              [loading]="loadingClients"
              (querySearch)="onClientQuerySearch($event)"
              (selectChangeItem)="onClientSelected($event)"
            ></app-select-autocomplete>
          </div>
          <div class="col-md-6 col-12 mt-2">
            <app-custom-input
              label="Gallons Collected"
              type="number"
              placeholder="0"
              [control]="form.get('gallons')!"
            ></app-custom-input>
          </div>
        </div>
      </div>

      <!-- ── Section 3: Notes ── -->
      <div class="kite-section-card mb-0">
        <div class="kite-section-title">
          <span>Notes</span>
        </div>
        <div class="row g-2">
          <div class="col-12">
            <app-textarea
              label="Notes"
              [control]="form.get('input_notes')!"
              rows="3"
            ></app-textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div dialog-actions class="d-flex justify-content-end gap-2">
    <app-button variant="secondary" (onClick)="activeModal.dismiss('close')">Close</app-button>
    <app-button variant="primary" (onClick)="save()">Save</app-button>
  </div>
</app-personalized-dialog>
